import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { KibButtonNew } from '@chewy/kib-controls-react'
import { KibMoreHorizIcon } from '@chewy/kib-icons-react'

import type { PopperAction } from '~/components/common/ActionsPopper'
import RhapActionsPopper from '~/components/common/RhapActionsPopper'

import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css'
import styles from './PrescriptionActionsCell.module.scss'

const PrescriptionActionsCell = ({ actions }: { actions?: PopperAction[] }) => {
  const { t } = useTranslation(['Soap'])

  const buttonRef = useRef<HTMLButtonElement>(null)

  return (
    <>
      <KibButtonNew
        iconOnly
        aria-label={t('Soap:CARE_DUE_WIDGET.ACTIONS_BUTTON')}
        className={styles.button}
        emphasis="tertiary"
        icon={<KibMoreHorizIcon />}
        ref={buttonRef}
        size="small"
        theme="utility"
      />
      <RhapActionsPopper
        actions={actions}
        placement="left"
        popperModifiers={[
          {
            name: 'offset',
            options: {
              offset: [35, 5],
            },
          },
        ]}
        trigger={buttonRef}
      />
    </>
  )
}

export default PrescriptionActionsCell
